"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setApiDefaults = exports.api = void 0;

var _tslib = require("tslib");

var _axios = _interopRequireDefault(require("axios"));

var _account = require("../account");

var _utility = require("./utility");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* istanbul ignore file */


var api = _axios["default"].create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, max-age=0'
  }
});

exports.api = api;
api.interceptors.request.use(function (config) {
  var token = (0, _account.getToken)();
  var transactionId = (0, _utility.getTransactionId)();

  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }

  if (transactionId) {
    config.headers['X-Transaction-ID'] = transactionId;
  }

  return config;
});
api.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  var _a;

  var data = ((error === null || error === void 0 ? void 0 : error.response) || {}).data;
  var message = (_a = data === null || data === void 0 ? void 0 : data.errors) === null || _a === void 0 ? void 0 : _a[0];
  return Promise.reject((0, _tslib.__assign)((0, _tslib.__assign)({}, error), {
    response: (0, _tslib.__assign)((0, _tslib.__assign)({}, error.response), {
      data: (0, _tslib.__assign)({
        text: (message === null || message === void 0 ? void 0 : message.text) || 'Oops something went wrong',
        code: (message === null || message === void 0 ? void 0 : message.code) || error.status
      }, data)
    })
  }));
});

var setApiDefaults = function setApiDefaults(_a) {
  var baseURL = _a.baseURL,
      locale = _a.locale;
  _axios["default"].defaults.baseURL = baseURL;
  _axios["default"].defaults.headers.common['Accept-Language'] = locale;
};

exports.setApiDefaults = setApiDefaults;